import { DataQueryKey, UseDataQuery } from '../../../hooks/useDataQuery/dataQuery.types';
import { GetOrderParams, GetOrderSummaryParams } from './order.types';

export const getOrderSummaryQueryKey = (
  params: GetOrderSummaryParams,
): UseDataQuery['queryKey'] => [
  DataQueryKey.ORDER_CALCULATE_SUMMARY,
  params.orderId,
  params.urlParams,
];

export const getOrderQueryKey = (params: GetOrderParams): UseDataQuery['queryKey'] => [
  DataQueryKey.ORDER,
  params.orderId,
];

export const getOfflineOrderHistoriesKey = (params: GetOrderParams): UseDataQuery['queryKey'] => [
  'offline-order-histories',
  params.orderId,
];
